(function () {
  if (window.ClVideoReels) return;
  var instances = new Map();
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || instances.has(root)) return;
    var cleanups = [];
    var videos = Array.from(root.querySelectorAll('video'));
    var activeVideo = videos[0];
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio > 0.6) {
          var desktop = window.matchMedia('(min-width: 768px)').matches;
          if (!v._clUserPaused && (!desktop || v === activeVideo)) v.play().catch(function () {});
        } else if (!v.paused) v.pause();
      });
    }, { threshold: [0, 0.6] }) : null;

    root.querySelectorAll('.cl-reels__card').forEach(function (card) {
      var v = card.querySelector('video');
      if (!v) return;
      var play = card.querySelector('[data-reel-play]');
      var mute = card.querySelector('[data-reel-mute]');
      var label = v.getAttribute('aria-label') || 'video';
      v._clUserPaused = reduced;
      function sync() {
        play.setAttribute('aria-pressed', String(!v.paused));
        play.setAttribute('aria-label', (v.paused ? 'Play ' : 'Pause ') + label);
        mute.setAttribute('aria-pressed', String(!v.muted));
        mute.setAttribute('aria-label', (v.muted ? 'Unmute ' : 'Mute ') + label);
      }
      function onPlay() { if (v.paused) { v._clUserPaused = false; v.play().catch(function () {}); } else { v._clUserPaused = true; v.pause(); } }
      function onMute() { v.muted = !v.muted; sync(); }
      function onStarted() {
        activeVideo = v;
        videos.forEach(function (other) { if (other !== v) other.pause(); });
        sync();
      }
      play.addEventListener('click', onPlay);
      mute.addEventListener('click', onMute);
      v.addEventListener('play', onStarted); v.addEventListener('pause', sync);
      if (io) io.observe(v);
      sync();
      cleanups.push(function () {
        play.removeEventListener('click', onPlay); mute.removeEventListener('click', onMute);
        v.removeEventListener('play', onStarted); v.removeEventListener('pause', sync); v.pause();
      });
    });
    instances.set(root, function () { if (io) io.disconnect(); cleanups.forEach(function (f) { f(); }); });
  }
  function destroy(root) { var f = instances.get(root); if (f) { f(); instances.delete(root); } }
  function initAll(scope) { (scope || document).querySelectorAll('[data-cl-reels]').forEach(init); }

  window.ClVideoReels = { init: init, destroy: destroy };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-cl-reels]').forEach(destroy);
  });
})();
